// restrict lengths to between min and max values
export const adjustValueForMinMax = (value: number, min: number, max: number): number => {
    const adjustedValue = value;
    // eslint-disable-next-line no-nested-ternary
    return adjustedValue < min ? min : adjustedValue > max ? max : adjustedValue;
};
